import { Button, Typography, useTheme } from '@material-ui/core';
import CloudIcon from '@material-ui/icons/Cloud';
import StorageIcon from '@material-ui/icons/Storage';
import LockIcon from '@material-ui/icons/Lock';
import SecurityIcon from '@material-ui/icons/Security';
import PersonIcon from '@material-ui/icons/Person';
import EmailIcon from '@material-ui/icons/Email';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import CodeIcon from '@material-ui/icons/Code';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import { useNavigate } from 'react-router-dom';
import { Page, Content } from '@backstage/core-components';

// Map operator names to their documentation paths and icons
const operators = [
  {
    name: 'GraviteeAPI Operator',
    description: 'Create and manage Gravitee APIs',
    icon: <CodeIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/graviteeapi-operator',
  },
  {
    name: 'Cloud Encryption Key Operator',
    description: 'Manage cloud encryption keys',
    icon: <LockIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/cloud-encryption-key-operator',
  },
  {
    name: 'Cloud Object Store Operator',
    description: 'Manage cloud object storage',
    icon: <StorageIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/cloud-object-store-operator',
  },
  {
    name: 'Cloud PostgreSQL Operator',
    description: 'Manage cloud PostgreSQL databases',
    icon: <DataUsageIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/cloud-postgresql-operator',
  },
  {
    name: 'Harness Org Operator',
    description: 'Manage Harness organizations',
    icon: <GroupWorkIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/harnessorganization-operator',
  },
  {
    name: 'MySQL Operator',
    description: 'Manage MySQL databases',
    icon: <StorageIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/mysql-operator',
  },
  {
    name: 'PrivateCloud Operator',
    description: 'Manage private cloud resources',
    icon: <CloudIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/privatecloud-operator',
  },
  {
    name: 'ResourceGroup Operator',
    description: 'Manage resource groups',
    icon: <AccountTreeIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/resourcegroup-operator',
  },
  {
    name: 'Service Account Operator',
    description: 'Manage service accounts',
    icon: <PersonIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/service-account-operator',
  },
  {
    name: 'SMTP Operator',
    description: 'Manage SMTP configurations',
    icon: <EmailIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/smtp-operator',
  },
  {
    name: 'VaultPath Operator',
    description: 'Manage Vault paths and secrets',
    icon: <SecurityIcon style={{ fontSize: 48 }} />,
    url: '/docs/default/component/hydra-docs/developer-tools/vaultpath-operator',
  },
];

export const OperatorsPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  
  return (
    <Page themeId="tool">
      <Content>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '30px',
            maxWidth: 1400,
            margin: '0 auto',
          }}
        >
          {operators.map(operator => (
            <Button
              key={operator.name}
              variant="contained"
              onClick={() => navigate(operator.url)}
              style={{
                height: 180,
                borderRadius: 24,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20,
                boxShadow: theme.shadows[4],
                background: theme.palette.background.paper,
                textTransform: 'none',
                transition: 'transform 0.2s',
                color: theme.palette.text.primary,
              }}
              onMouseOver={(e: any) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
              onMouseOut={(e: any) => { e.currentTarget.style.transform = 'scale(1)'; }}
            >
              <div style={{ color: theme.palette.primary.main, marginBottom: 15 }}>
                {operator.icon}
              </div>
              <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 8, color: theme.palette.text.primary, textAlign: 'center' }}>
                {operator.name}
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                {operator.description}
              </Typography>
            </Button>
          ))}
        </div>
      </Content>
    </Page>
  );
};
